import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../../../_uiComponents/WrapperComponents";
import DealerManagementGrid from "./views/DealerManagementGrid";


export default function DealerManagementWrapper() {
     const navigate = useNavigate();
    
     return (
          <>
               <MainLeftTitle title="Dealer Management">
                    <CreateButton
                         name="Add Dealer"
                         onClick={() => navigate("/app/dealer-data-manage/add")}
                    />
               </MainLeftTitle>

               <DealerManagementGrid />
          </>
     );
}